import { Modal, ModalProps } from 'ui';

import { PayPalAccountForm } from '../../forms/PayPalAccountForm/PayPalAccountForm';

interface PayPalAccountModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
}

const PayPalAccountModal = ({ opened, onClose, modalProps, title }: PayPalAccountModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title ?? 'Connect My PayPal'} {...modalProps}>
      <PayPalAccountForm onClose={onClose} />
    </Modal>
  );
};

export { PayPalAccountModal };
